import { render, staticRenderFns } from "./WorksOverlayFilter.vue?vue&type=template&id=108fb648&scoped=true"
import script from "./WorksOverlayFilter.vue?vue&type=script&lang=js"
export * from "./WorksOverlayFilter.vue?vue&type=script&lang=js"
import style0 from "./WorksOverlayFilter.vue?vue&type=style&index=0&id=108fb648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108fb648",
  null
  
)

export default component.exports